import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as DTOS from "../FeralScan.dtos";
import { IUserRegister, IUserUpdate } from "../actions/user.actions";

export const serviceApi = {
    login: (username: string, password: string, rememberMe: boolean) => {
        var client = new JsonServiceClient("");
        
        var loginRequest = new DTOS.Authenticate();
        loginRequest.userName = `${process.env.PRODUCT}~${username}`;
        loginRequest.password = password;
        loginRequest.provider = "credentials";
        loginRequest.rememberMe = rememberMe;

        const promise = client.post(loginRequest);
    
        return Observable.from(promise);
    },
    loginWithToken: (username: string, password: string) => {
        var client = new JsonServiceClient("");
        
        var loginRequest = new DTOS.Authenticate();
        loginRequest.userName = `token~${process.env.PRODUCT}~${username}`;
        loginRequest.password = password;
        loginRequest.provider = "credentials";
    
        const promise = client.post(loginRequest);
    
        return Observable.from(promise);
    },
    logout: () => {
        var client = new JsonServiceClient("");
        var requestData = new DTOS.Authenticate();
        requestData.provider = "logout";

        const promise = client.post(requestData);

        return Observable.from(promise);
    },
    getCurrentUser: () => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetAuthenticatedUser();

        const promise = client.get(request);
        return Observable.from(promise);
    },
    registerUser: (user: IUserRegister) => {
        var client = new JsonServiceClient("");
        
        var registerRequest = new DTOS.RegisterUser();
        registerRequest.fullName = user.fullName;
        registerRequest.surname = user.surname;
        registerRequest.password = user.password;
        registerRequest.email = user.email;
        registerRequest.mobile = user.mobileNumber;
        registerRequest.agreedTerms = user.agreedTerms;
        registerRequest.postCode = user.postcode;
        registerRequest.product = process.env.PRODUCT;
    
        // product fields
        if(user.platypusSeen !== undefined){
            registerRequest.platypusSeen = user.platypusSeen;
        }

        const promise = client.post(registerRequest);
        return Observable.from(promise);
    },
    updateUser: (user: IUserUpdate) => {
        var client = new JsonServiceClient("");
        
        var updateRequest = new DTOS.UpdateUser();
        updateRequest.fullName = user.fullName;
        updateRequest.surname = user.surname;
        updateRequest.email = user.email;
        updateRequest.mobile = user.mobileNumber;
        updateRequest.postCode = user.postcode;

        const promise = client.post(updateRequest);
        return Observable.from(promise);
    },
    sendPasswordReset: (username) => {
        var client = new JsonServiceClient("");
        
        var resetRequest = new DTOS.ResetUserPassword();
        resetRequest.userName = username;
    
        const promise = client.post(resetRequest);
        return Observable.from(promise);
    },
    sendActivateAccount: (username) => {
        var client = new JsonServiceClient("");
        
        var resetRequest = new DTOS.RequestAccountActivation();
        resetRequest.userName = username;
    
        const promise = client.get(resetRequest);
        return Observable.from(promise);
    },
    changePasswordFromToken: (token: string, newPassword: string) => {
        var client = new JsonServiceClient("");
        
        var resetRequest = new DTOS.ChangePasswordFromToken();
        resetRequest.token = token;
        resetRequest.newPassword = newPassword;
    
        const promise = client.post(resetRequest);
        return Observable.from(promise);
    },
    changePassword: (newPassword: string) => {
        var client = new JsonServiceClient("");
        
        var resetRequest = new DTOS.ChangeUserPassword();
        resetRequest.newPassword = newPassword;
    
        const promise = client.put(resetRequest);
        return Observable.from(promise);
    },
    changeUserOptOutStatus: (optOutStatus: boolean) => {
        var client = new JsonServiceClient("");
        
        var request = new DTOS.ChangeUserOptOutStatus();
        request.optOutStatus = optOutStatus;
    
        const promise = client.put(request);
        return Observable.from(promise);
    },
    activateUserAccount: (token: string) => {
        var client = new JsonServiceClient("");
        
        var resetRequest = new DTOS.ActiveUserAccount();
        resetRequest.token = token;
    
        const promise = client.get(resetRequest);
        return Observable.from(promise);
    },
    isValidChangePasswordToken: (token: string) => {
        var client = new JsonServiceClient("");
        
        var validTokenRequest = new DTOS.IsValidChangePasswordToken();
        validTokenRequest.token = token;
    
        const promise = client.post(validTokenRequest);
        return Observable.from(promise);
    },
    updateUserPreferences: (preferences) => {
        var client = new JsonServiceClient("");
        
        var updatePreferencesRequest = new DTOS.UpdateUserPreferences();
        updatePreferencesRequest.userPreferences = preferences;
    
        const promise = client.put(updatePreferencesRequest);
        return Observable.from(promise);
    },
    assignUserRole: (userId: number, roleId: number, plotId?: number) => {
        var client = new JsonServiceClient("");
        
        var assignUserRole = new DTOS.AssignUserRole();
        assignUserRole.userId = userId;
        assignUserRole.roleId = roleId;
        assignUserRole.plotId = plotId;
    
        const promise = client.post(assignUserRole);
        return Observable.from(promise);
    },
    unassignUserRole: (userRoleId: number) => {
        var client = new JsonServiceClient("");
        
        var unassignUserRole = new DTOS.UnassignUserRole();
        unassignUserRole.userRoleId = userRoleId;
    
        const promise = client.delete(unassignUserRole);
        return Observable.from(promise);
    }
};
